export default {
  meta: {
    title: '拓店进展统计',
    parentPath: ['/storemanage', '/analyze/report'],
    url: '/storemanage/progress', // 埋点用，记录所属模块
    // eventId: '0c9e1829-7e85-460e-85b5-83fde61fdbfa'
  },
};
